import script from "./config-base.vue?vue&type=script&lang=jsx"
export * from "./config-base.vue?vue&type=script&lang=jsx"

const __exports__ = script;

export default __exports__